import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import InvoiceEditor from "@/pages/InvoiceEditor";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Customers from "@/pages/Customers";
import Expenses from "@/pages/Expenses";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import ReportEditor from "@/pages/ReportEditor";
import ReportDetail from "@/pages/ReportDetail";
import ReportToEstimate from "@/pages/ReportToEstimate";
import Catalog from "@/pages/Catalog";
import AiAssistant from "@/pages/AiAssistant";
import Billing from "@/pages/Billing";
import Landing from "@/pages/Landing";
import JobBoard from "@/pages/JobBoard";
import MyBids from "@/pages/MyBids";
import ClientAuth from "@/pages/ClientAuth";
import ClientDashboard from "@/pages/ClientDashboard";
import MechanicProfile from "@/pages/MechanicProfile";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth redirect (session_id in URL fragment) before anything else.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
      <Route path="/invoices/new" element={<ProtectedRoute><InvoiceEditor /></ProtectedRoute>} />
      <Route path="/invoices/:id" element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
      <Route path="/invoices/:id/edit" element={<ProtectedRoute><InvoiceEditor /></ProtectedRoute>} />
      <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/reports/new" element={<ProtectedRoute><ReportEditor /></ProtectedRoute>} />
      <Route path="/reports/:id" element={<ProtectedRoute><ReportDetail /></ProtectedRoute>} />
      <Route path="/reports/:id/estimate" element={<ProtectedRoute><ReportToEstimate /></ProtectedRoute>} />
      <Route path="/catalog" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
      <Route path="/ai" element={<ProtectedRoute><AiAssistant /></ProtectedRoute>} />
      <Route path="/jobs" element={<ProtectedRoute><JobBoard /></ProtectedRoute>} />
      <Route path="/my-bids" element={<ProtectedRoute><MyBids /></ProtectedRoute>} />
      <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/client/register" element={<ClientAuth mode="register" />} />
      <Route path="/client/login" element={<ClientAuth mode="login" />} />
      <Route path="/client" element={<ClientDashboard />} />
      <Route path="/mechanic/:email" element={<MechanicProfile />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/" element={<Landing />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
